import $ from 'jquery';
import { stopAiLoader } from '~core/aiLoader';
import { applySelectedRemoveBg } from './applySelectedRemoveBg';

export function showRemoveBgDialog(
  removebgRawImage,
  removebgImageUrl,
  startTime
) {
  // Clean up any existing modal and its event listeners
  const existingModal = $('#removeBgOptionsModal');
  if (existingModal.length) {
    existingModal.off('hidden.bs.modal');
    existingModal.modal('hide');
    existingModal.remove();
  }

  // Create and show the main modal immediately
  const modalHtml = `
    <div class="modal fade" id="removeBgOptionsModal" tabindex="-1" role="dialog" style="padding-top: 10vh;">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title">Anteprima immagine</h5>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="max-height: 70vh; overflow-y: auto; padding: 25px;">
            <div class="text-center">
              <div class="card shadow-sm" style="border-radius: 8px; display: inline-block; position: relative;">
                <div class="card-img-top" style="height: 450px; overflow: hidden; display: flex; align-items: center; justify-content: center; position: relative;">
                  <div class="image-protection-overlay"></div>
                  <img src="${removebgImageUrl}" class="img-fluid protected-image" style="max-height: 100%; max-width: 100%; object-fit: contain;" alt="Anteprima immagine">
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12 text-center">
                <p class="text-muted">Se sei soddisfatto del risultato, clicca su "Accetta"</p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Annulla</button>
            <button type="button" class="btn btn-primary" id="acceptImage">Accetta</button>
          </div>
        </div>
      </div>
    </div>
  `;

  // Add modal to body
  $('body').append(modalHtml);

  // Show modal immediately
  $('#removeBgOptionsModal').modal({
    backdrop: 'static',
    keyboard: true,
  });

  // Close the loader after modal is shown
  stopAiLoader();

  // Handle accept button click
  $('#acceptImage').on('click', function () {
    $('#removeBgOptionsModal').modal('hide');

    // Clean up
    $('#removeBgOptionsModal').on('hidden.bs.modal', function () {
      applySelectedRemoveBg(removebgRawImage, removebgImageUrl, startTime).then(
        () => {
          $(this).remove();
          $('.modal-backdrop').remove();
          $('body').removeClass('modal-open');
        }
      );
    });
  });
}
